export const ACTIONS_PARTY_AGENT = {
	PARTY_AGENT_EC8A: 'party_agent_ec8a',
	PARTY_AGENT_EC8B: 'party_agent_ec8b',
	PARTY_AGENT_EC8C: 'party_agent_ec8c',
	PARTY_AGENT_EC8D: 'party_agent_ec8d',
} as const;
